import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const JIRA_SETTINGS_QUERY = gqlTagGira`
  query JiraBusinessSettings {
    jiraSettings {
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
        format
      }
    }
  }
`;
